<template>
    <div :class="['toast', { show: Boolean(message) }]">
        <span class="tk">✓</span>{{ message }}
    </div>
</template>

<script>
export default {
    name: 'StarterPackToast',
    props: {
        message: {
            type: String,
            default: '',
        },
    },
}
</script>

<style lang="scss" scoped>
@import '@/vars.sass';

.toast {
    position: fixed;
    z-index: 90;
    bottom: 84px;
    left: 50%;
    display: flex;
    align-items: center;
    gap: 9px;
    padding: 11px 20px;
    color: #fff;
    font-family: Geologica, Inter, system-ui, sans-serif;
    font-size: 13px;
    font-weight: 600;
    pointer-events: none;
    background: $dark-new;
    border-radius: 10px;
    opacity: 0;
    transform: translateX(-50%) translateY(14px);
    transition: opacity 0.25s, transform 0.25s;
}

.toast.show {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
}

.toast .tk {
    color: $pop-new;
}
</style>
